import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Category from '../views/Category.vue'
import NewReservation from '../views/reservations/NewReservation'
import MyReservations from '../views/reservations/MyReservations'
import CompleteReservation from '../views/reservations/CompleteReservation'


Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/category/:id',
    name: 'Category',
    props: true,
    component: Category
  },
  {
    path: '/reservation/new',
    component: NewReservation
  },
  {
    path: '/reservation',
    component: MyReservations
  },
  {
    path: '/reservation/complete',
    component: CompleteReservation
  },
  {
    path: '/reservation/:actionToken',
    component: MyReservations
  },
  {
    path: '/:tableId',
    component: Home
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

export default router
